var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0285 0.000220649C27.9242 0.000220649 31.5922 0.910346 35.0332 2.67341L35.4881 2.90103L35.0901 3.21378C34.1233 3.9816 33.3555 4.97685 32.8719 6.11422L32.7298 6.42697L32.4456 6.28484C29.8009 5.03366 26.9857 4.37966 24.0568 4.37966C13.2227 4.37966 4.43606 13.1948 4.43606 24.0004C4.43606 34.806 13.1942 43.6213 24.0285 43.6213C34.8626 43.6213 43.6493 34.8062 43.6493 24.0004C43.6493 21.4129 43.1659 18.882 42.1421 16.4933L42 16.1805L42.3128 16.0384C43.4786 15.6118 44.5024 14.901 45.327 13.9909L45.6398 13.5928L45.8389 14.0479C47.2892 17.2043 48 20.5598 48 23.9436C48 37.1663 37.2227 47.9436 24 47.9436C10.7773 47.9436 0 37.1663 0 23.9438C0 10.7213 10.7773 -0.0562168 24.0285 0.000220649ZM24.0285 13.081C30.0285 13.081 34.9479 17.9721 34.9762 24.0289C34.9762 30.0857 30.0853 34.9768 24.0285 34.9768C17.9715 34.9768 13.0806 30.0857 13.0806 24.0289C13.0806 17.9721 18 13.081 24.0285 13.081ZM39.6968 4.03841C42.4607 4.03841 44.7015 6.27903 44.7015 9.04316C44.7015 11.8071 42.4609 14.0479 39.6968 14.0479C36.9326 14.0479 34.692 11.8073 34.692 9.04316C34.692 6.27903 36.9326 4.03841 39.6968 4.03841Z",
    fill: "#3880FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.b4758d0e5cd69308003b01b5351cf82a.svg";
export { ForwardRef as ReactComponent };